import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Document from '../../../../../shared/shim/react-pdf/Document';
import Page from '../../../../../shared/shim/react-pdf/Page';
import FooterWrapper, {
    inferFooterWrapperFixPacket,
} from './FooterDocumentWrapper';
import DocumentFooter, {
    inferDocumentModalFooter,
} from './DocumentModalFooter';
import { DocumentCallback } from 'react-pdf/dist/cjs/shared/types';
import { inferRedact } from 'shared/shim/react-pdf/PageCanvas';
import {
    useClickAway,
    usePageLeave,
    useTimeoutFn,
    useUpdateEffect,
} from 'react-use';
import isPointerInside from 'shared/helpers/isPointerInside';

import { CircularProgress, Typography } from '@mui/material';
import { PDFDocument } from 'pdf-lib';
import { DocumentPDF } from '../../solicitor-viewer/components/DocumentViewer';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { ManagePacketService } from 'services';
import { Toast, Utils } from 'shared/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { BroadcastActions } from 'state/broadcast/Action';
import { SocketActions } from 'state/socket/Action';
import { AxiosError } from 'axios';
import { APIManager, axios } from 'shared/manager';
import { useLeavePrompt } from 'shared/helpers/UseExitPrompt';

const DocumentModal: React.FC<Props> = React.forwardRef(
    (
        {
            callbackClosingModal,
            callbackOpenModal,
            callbackSavingModal,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            pdfUrl,
            packetId,
        },
        ref
    ): React.ReactElement => {
        const containerModalRef = React.useRef<HTMLDivElement | null>(null);
        const [verticeObject, setVerticesObject] = React.useState<
            VerticeReportFormObject[]
        >([]);
        const [pdfName, setPdfName] = React.useState<string | null>(null);
        const [numPages, setNumPages] = React.useState<number | null>(null);
        const [pdfDocumentUrl, setPdfUrl] = React.useState<Uint8Array | null>(
            null
        );
        const innerModalRef = React.useRef<HTMLDivElement | null>(null);
        const handleArrayBufferToBase64 = React.useCallback(
            (wrapper: Uint8Array) => {
                let binary = '';
                const bytes = wrapper;
                const len = bytes.byteLength;
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary); // viewer cache
            },
            []
        );

        const pdfDocumentData = React.useMemo(
            () =>
                pdfDocumentUrl === null
                    ? undefined
                    : `data:application/pdf;base64,${handleArrayBufferToBase64(
                          pdfDocumentUrl
                      )}`,
            [pdfDocumentUrl, handleArrayBufferToBase64]
        );

        const [pdfInitialization, setPdfInitialization] =
            React.useState<boolean>(false);

        const redactRef = React.useRef<Array<inferRedact> | null>(null);
        const canvasRef = React.useRef<Array<HTMLCanvasElement>>([]);
        const htmlsRef = React.useRef<Array<HTMLDivElement>>([]);
        const documentRef = React.useRef<DocumentPDF | null>(null);
        const footerWrapperRef =
            React.useRef<inferFooterWrapperFixPacket | null>(null);
        const footerRef = React.useRef<inferDocumentModalFooter | null>(null);

        const handle = useFullScreenHandle();
        const [isFullScreen, setFullScreen] = React.useState<boolean>(false);
        // const [historyRedacts, setRedactsHistory] = React.useState<populatedRedacts>({});
        const [open, setOpen] = React.useState(false);
        useUpdateEffect(() => {
            if (open) {
                if (isFullScreen) {
                    handle.enter();
                } else {
                    handle.exit();
                }
            }
        }, [isFullScreen]);

        // const [historyRedacts, setRedactsHistory] = React.useState<populatedRedacts>({});

        /**
         * handle action when document load is successful
         */
        const onDocumentLoadSuccess = React.useCallback(
            (props: DocumentCallback) => {
                const { current: footer } = footerRef;
                setNumPages(props.numPages);

                if (open && props.numPages) {
                    footer?.setDefaultDocumentData(
                        pdfName,
                        verticeObject.length,
                        packetId
                    );
                }
            },
            [open, packetId, pdfName, verticeObject.length]
        );

        const handleReportFilename = React.useCallback(
            (filename: string, type: string) =>
                filename?.split('/').find((segment) => segment.includes(type)),
            []
        );
        const handleCleanReportFilename = React.useCallback(
            (filename: string) => filename?.split('.pdf').at(0),
            []
        );

        const callbackForPromptAlert = React.useCallback(() => {
            ManagePacketService.patchOperatorAction({
                open: false,
                packetId: packetId ?? '',
            })
                .then(() => {
                    const { current: modalRef } = innerModalRef;
                    modalRef?.classList.add('patch');
                    // Utils.handleSuccessResponse(response);
                    // navigate('/not-expected-packet', {
                    //     replace: true,
                    //     state: {
                    //         ...defaultState,
                    //         isOpen: false,
                    //     },
                    // });
                    // window.history.state.isOpen = false;
                    //               window.history.replaceState({ ba: false }, '');
                })
                .catch(Utils.handleErrorResponse);
        }, [packetId]);

        const [, showLeavePrompt] = useLeavePrompt(
            false,
            callbackForPromptAlert
        );
        const [isLeavePage, setLeavePage] = React.useState<boolean>(false);
        usePageLeave(() => {
            setLeavePage(true);
        });
        const handlePatchingOperatorLockWithTimeout = React.useCallback(() => {
            ManagePacketService.patchOperatorAction({
                open: true,
                packetId: packetId ?? '',
            })
                .then(() => {
                    // const { current: modalRef } = innerModalRef;
                    // modalRef?.classList.add('patch');
                    // Utils.handleSuccessResponse(response);
                    // navigate('/not-expected-packet', {
                    //     replace: true,
                    //     state: {
                    //         ...defaultState,
                    //         isOpen: false,
                    //     },
                    // });
                    // window.history.state.isOpen = false;
                    //               window.history.replaceState({ ba: false }, '');
                })
                .catch(Utils.handleErrorResponse);
        }, [packetId]);
        const [, cancelOperatorLock, resetOperatorLock] = useTimeoutFn(
            handlePatchingOperatorLockWithTimeout,
            500
        );
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const handleMouseEnter = React.useCallback(
            (event: any) => {
                const { current: modalRef } = innerModalRef;

                if (isPointerInside(modalRef, event)) {
                    if (modalRef?.classList.contains('patch')) {
                        modalRef.classList.remove('patch');
                        resetOperatorLock();
                    }
                    setLeavePage(false);
                }
            },
            [resetOperatorLock]
        );
        useUpdateEffect(() => {
            const { current: modalRef } = innerModalRef;
            if (modalRef) {
                if (isLeavePage) {
                    modalRef.addEventListener('mouseenter', handleMouseEnter);
                } else {
                    modalRef.removeEventListener(
                        'mouseenter',
                        handleMouseEnter
                    );
                }
            }
        }, [isLeavePage]);

        React.useLayoutEffect(() => {
            if (!open) {
                setPdfUrl(null);
                setPdfInitialization(false);
                cancelOperatorLock();
                showLeavePrompt(false);
            } else {
                cancelOperatorLock();
                showLeavePrompt(true);
            }
        }, [open]);
        React.useEffect(() => {
            cancelOperatorLock();
            return () => {
                cancelOperatorLock();
            };
        }, []);
        React.useEffect(() => {
            if (open && packetId) {
                ManagePacketService.getReportVertices({ packetId })
                    .then((response) => {
                        const { report, verticesList } = response.data.data;

                        if (report) {
                            const reportNameBulk = handleReportFilename(
                                report,
                                '.pdf'
                            );
                            const reportName = handleCleanReportFilename(
                                reportNameBulk ?? ''
                            );

                            if (reportName) {
                                setVerticesObject(
                                    Array.from(verticesList ?? []).map(
                                        (el: any, index) => ({
                                            ...el,
                                            className: `verticesReport_${index}`,
                                        })
                                    )
                                );

                                setPdfName(reportName);
                                APIManager.sendGet(
                                    report,
                                    false,
                                    {},
                                    { responseType: 'arraybuffer' },
                                    axios
                                )
                                    .then(async (test) => {
                                        const buffer = test.data;
                                        PDFDocument.load(buffer).then(
                                            (value) => {
                                                const verticeObjects: VerticeReportFormObject[] =
                                                    verticesList ?? [];
                                                const form = value.getForm();
                                                for (
                                                    let index = 0;
                                                    index <
                                                    verticeObjects.length;
                                                    // eslint-disable-next-line no-plusplus
                                                    index++
                                                ) {
                                                    const element =
                                                        verticeObjects[index];
                                                    const verticeField =
                                                        form.createTextField(
                                                            `verticesReport_${index}`
                                                        );
                                                    const page = value
                                                        .getPages()
                                                        .at(
                                                            element.pageNumber -
                                                                1
                                                        );
                                                    if (page) {
                                                        const PageHeight =
                                                            page.getHeight();

                                                        verticeField.addToPage(
                                                            page,
                                                            {
                                                                x: element.x1,
                                                                y:
                                                                    PageHeight -
                                                                    17 -
                                                                    (element.y1 +
                                                                        (element.y4 -
                                                                            element.y1) /
                                                                            2),
                                                                height:
                                                                    element.y4 -
                                                                    element.y1,
                                                                width:
                                                                    element.x2 -
                                                                    element.x1,
                                                            }
                                                        );
                                                    }
                                                }

                                                value
                                                    .save({})
                                                    .then((bufferPDF) => {
                                                        setPdfUrl(bufferPDF);
                                                    });
                                            }
                                        );
                                    })
                                    .catch((error: Error) => {
                                        if (
                                            error !== null &&
                                            error instanceof AxiosError &&
                                            error.code === 'ERR_NETWORK'
                                        ) {
                                            Toast.showErrorMessage(
                                                'No internet connection, Please try again!'
                                            );
                                        } else {
                                            Utils.handleErrorResponse(error);
                                        }
                                        setOpen(false);
                                    });
                            }
                        }
                    })
                    .catch((error) => {
                        // setOpen(false);
                        if (
                            error !== null &&
                            error instanceof AxiosError &&
                            error.code === 'ERR_NETWORK'
                        ) {
                            Toast.showErrorMessage(
                                'No internet connection, Please try again!'
                            );
                        } else {
                            Utils.handleErrorResponse(error);
                        }
                    });

                setPdfInitialization(true);
            }
        }, [packetId, open]);

        /**
         * prepare document modal when trigger callback from footer to open modal
         */
        const handleModalChangedInsideFooter = React.useCallback(() => {
            const { current: footer } = footerRef;
            if (open && numPages) {
                // documentRef.current?.linkService.current.pdfDocument.
                footer?.setDefaultDocumentData(
                    pdfName,
                    verticeObject.length,
                    packetId
                );
            }
        }, [numPages, open, packetId, pdfName, verticeObject.length]);

        const outsideContainerModalRef = React.useRef<HTMLDivElement>(null);

        /**
         * handle clickaway listener for closing modal in backdrop selection
         * @param {MouseEvent} parameteeventrNameHere - event
         */
        const handleClickAwayListener = React.useCallback(
            (event: MouseEvent) => {
                const { current: footerWrapper } = footerWrapperRef;
                const { current: footer } = footerRef;
                const { current: container } = containerModalRef;
                if (
                    container &&
                    footerWrapper?.isPointerOnFooter(event) === false &&
                    isPointerInside(container, event) &&
                    footer?.isModalFooterActive() === false
                ) {
                    // setOpen(false);
                }
            },
            []
        );
        useClickAway(outsideContainerModalRef, handleClickAwayListener);

        /**
         * handle modal open
         */
        const handleOpen = React.useCallback((): void => {
            setOpen(true);

            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, [callbackOpenModal]);
        /**
         * handle modal close
         */
        const handleClose = React.useCallback((): void => {
            const { current: footer } = footerRef;
            if (footer?.isModalFooterActive() === false) {
                setOpen(false);
                setVerticesObject([]);
                setPdfName('');
                setNumPages(0);
                setPdfUrl(null);
                if (typeof callbackClosingModal === 'function')
                    callbackClosingModal(packetId);
            }
        }, [callbackClosingModal, packetId]);

        const handleCloseSamePacket = React.useCallback((): void => {
            const { current: footer } = footerRef;
            if (footer?.isModalFooterActive() === false) {
                setOpen(false);
                setVerticesObject([]);
                setPdfName('');
                setNumPages(0);
                setPdfUrl(null);
                if (typeof callbackClosingModal === 'function')
                    callbackClosingModal(null);
            }
        }, [callbackClosingModal]);

        /**
         * handle save process from footer
         */
        const handleSave = React.useCallback(async () => {
            setOpen(false);
            setVerticesObject([]);
            setPdfName('');
            setNumPages(0);
            setPdfUrl(null);
            if (typeof callbackSavingModal === 'function') {
                callbackSavingModal(packetId);
            }
        }, [callbackSavingModal, packetId]);
        const [currentZoom, setCurrentZoom] = React.useState<number>(20);
        const [width, setWidth] = React.useState<number>(400 + 25 * 20);
        const [height, setHeight] = React.useState<number>(400 + 25 * 20);
        const handleZoom = React.useCallback((value: number) => {
            setCurrentZoom(value);
            setWidth(400 + 25 * value);
            setHeight(400 + 25 * value);
        }, []);
        const handleSuccessPageLoad = React.useCallback(
            (pageIndex: any) => {
                const { current: footer } = footerRef;
                if (open && numPages) {
                    // eslint-disable-next-line no-underscore-dangle
                    const index = pageIndex + 1;

                    const objectBindings = verticeObject.filter(
                        (e) => e.pageNumber === index
                    );

                    if (
                        typeof objectBindings === 'object' &&
                        Array.isArray(objectBindings) &&
                        objectBindings.length > 0
                    ) {
                        footer?.setDocumentVerticesBinding(
                            index,
                            Array.from(objectBindings).map((e) => {
                                const htmlDiv = htmlsRef.current.at(
                                    e.pageNumber - 1
                                );
                                const { className } = e;
                                const element: Element | undefined | null =
                                    htmlDiv?.children.item(1);
                                const elementCollectionLength: number =
                                    element?.childElementCount ?? 0;

                                for (
                                    let index = 0;
                                    index < elementCollectionLength;
                                    // eslint-disable-next-line no-plusplus
                                    index++
                                ) {
                                    const child = element?.children
                                        .item(index)
                                        ?.children.item(0);

                                    if (
                                        child &&
                                        child.getAttribute('name') === className
                                    ) {
                                        return {
                                            ...e,
                                            element: child as HTMLInputElement,
                                        };
                                    }
                                }

                                return e;
                            })
                        );
                    } else {
                        footer?.setDocumentSuccess();
                    }
                }
            },
            [numPages, open, verticeObject]
        );
        const documentClassName = React.useMemo(() => {
            if (currentZoom < 30) {
                return 'document-viewer low';
            }
            if (currentZoom >= 30 && currentZoom < 50) {
                return 'document-viewer medium';
            }
            if (currentZoom >= 50) {
                return 'document-viewer high';
            }
            return 'document-viewer';
        }, [currentZoom]);

        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
            }),
            [handleOpen, handleClose]
        );
        const socketState = useSelector((state: any) => state.socketState);
        const socketEvent = React.useMemo(
            () => socketState.socketData.eventName,
            [socketState.socketData.eventName]
        );
        const profileState = useSelector((state: any) => state.profileState);

        const isTabActive = useSelector(
            (state: any) => state.carryState.visibilityState
        );
        const dispatch = useDispatch();
        const [isGoingBackBySocket, setGoingBackBySocket] =
            React.useState<boolean>(false);
        const [isGoingBackBySocketSamePacket, setGoingBackBySocketSamePacket] =
            React.useState<boolean>(false);

        useUpdateEffect(() => {
            if (socketEvent !== null && open) {
                if (socketEvent === 'operatorAction') {
                    if (
                        // eslint-disable-next-line no-underscore-dangle
                        profileState.userInfo._id ===
                            socketState.socketData.operatorId &&
                        isTabActive === false
                    ) {
                        dispatch(
                            BroadcastActions.SetBroadcastProgression(true)
                        );
                        setGoingBackBySocketSamePacket(
                            socketState.socketData.packetId === packetId
                        );
                        setGoingBackBySocket(
                            socketState.socketData.packetId !== packetId
                        );
                    }
                }
                dispatch(SocketActions.ResetSocketEvent({}));
            }
        }, [socketEvent]);

        React.useEffect(() => {
            if (isGoingBackBySocket && open) {
                handleClose();
                setGoingBackBySocket(false);
            }
        }, [isGoingBackBySocket]);

        React.useEffect(() => {
            if (isGoingBackBySocketSamePacket && open) {
                handleCloseSamePacket();
                setGoingBackBySocketSamePacket(false);
            }
        }, [isGoingBackBySocketSamePacket]);

        return (
            <Box className="DocumentModal">
                <Modal
                    ref={innerModalRef}
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    disableScrollLock
                >
                    <Box className="container-review-packet-footer-content">
                        <FullScreen
                            handle={handle}
                            className="handle-fullscreen-viewer"
                            onChange={(state) => {
                                if (!state) setFullScreen(false);
                            }}
                        >
                            <FooterWrapper
                                innerRef={footerRef}
                                ref={footerWrapperRef}
                                Footer={DocumentFooter}
                                onModalChanged={handleModalChangedInsideFooter}
                                onClose={handleSave}
                                onBack={handleClose}
                                onZoomChanged={handleZoom}
                                documentRef={documentRef}
                                canCategorize={false}
                                isFullScreen={isFullScreen}
                                setFullScreen={setFullScreen}
                                unexpectedType={false}
                                allowRerun={false}
                                updateGroup={false}
                                allowRevalidation={false}
                            >
                                <Box
                                    className="container-document-modal"
                                    ref={containerModalRef}
                                >
                                    <Box
                                        className="inner-container-document"
                                        ref={outsideContainerModalRef}
                                    >
                                        <Document
                                            className={documentClassName}
                                            ref={documentRef}
                                            renderMode="canvas"
                                            file={pdfDocumentData}
                                            error={
                                                <Box className="align-loader">
                                                    <Typography variant="h3">
                                                        Document Missing
                                                    </Typography>
                                                </Box>
                                            }
                                            noData={
                                                <Box className="align-loader">
                                                    {typeof pdfDocumentData ===
                                                        'undefined' ||
                                                    pdfInitialization ===
                                                        false ? (
                                                        <CircularProgress
                                                            className="mr-2 margin-loader"
                                                            size={54}
                                                            color="inherit"
                                                            title="progress loading"
                                                        />
                                                    ) : (
                                                        <Typography variant="h3">
                                                            Document Missing
                                                        </Typography>
                                                    )}
                                                </Box>
                                            }
                                            loading={
                                                <Box className="align-loader">
                                                    <CircularProgress
                                                        className="mr-2 margin-loader"
                                                        size={54}
                                                        color="inherit"
                                                        title="progress loading"
                                                    />
                                                </Box>
                                            }
                                            onLoadSuccess={
                                                onDocumentLoadSuccess
                                            }
                                        >
                                            {Array.from({
                                                length: numPages ?? 0,
                                            }).map((el, index) => (
                                                <Page
                                                    inputRef={(_ref) => {
                                                        if (_ref !== null) {
                                                            htmlsRef.current[
                                                                index
                                                            ] = _ref;
                                                        }
                                                    }}
                                                    renderTextLayer={false}
                                                    renderAnnotationLayer
                                                    renderXFALayer={false}
                                                    renderForms
                                                    className="page-document-viewer"
                                                    key={`${index}-viewer`}
                                                    pageNumber={index + 1}
                                                    loading={
                                                        <Box className="align-loader">
                                                            <CircularProgress
                                                                className="mr-2 margin-loader"
                                                                size={54}
                                                                color="inherit"
                                                                title="progress loading"
                                                            />
                                                        </Box>
                                                    }
                                                    error={
                                                        <Box className="align-loader">
                                                            <Typography variant="h3">
                                                                Document Page
                                                                Missing
                                                            </Typography>
                                                        </Box>
                                                    }
                                                    redactRef={(_ref) => {
                                                        if (
                                                            _ref !== null &&
                                                            redactRef.current !==
                                                                null
                                                        ) {
                                                            redactRef.current[
                                                                index
                                                            ] = _ref;
                                                        }
                                                    }}
                                                    canvasRef={(_ref) => {
                                                        if (_ref !== null) {
                                                            canvasRef.current[
                                                                index
                                                            ] = _ref;
                                                        }
                                                    }}
                                                    height={height}
                                                    width={width}
                                                    onRenderAnnotationLayerFinish={() =>
                                                        handleSuccessPageLoad(
                                                            index
                                                        )
                                                    }
                                                />
                                            ))}
                                        </Document>
                                    </Box>
                                </Box>
                            </FooterWrapper>
                        </FullScreen>
                    </Box>
                </Modal>
            </Box>
        );
    }
);

export default DocumentModal;
